import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ReactComponent as Icpassword } from "../../../assets/ic-password.svg";
import { Box, TextField, Button } from "@mui/material";
import { validationSchemaForgotPassword } from "../../../validation/ValidationSchema";
import { useNavigate } from "react-router-dom";
import { forgotPassword, resendOTP } from "../../../features/auth/authThunk";
import { useDispatch, useSelector } from "react-redux";
import {
  selectResetPasswordError,
  selectResetPasswordStatus,
} from "../../../features/auth/authSlice";

export default function Forgot_Password() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const resetPasswordStatus = useSelector(selectResetPasswordStatus);
  const resetPasswordError = useSelector(selectResetPasswordError);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchemaForgotPassword),
  });

  const onSubmit = async (data) => {
    try {
      const response = await dispatch(resendOTP(data.email)).unwrap();
      if (response.success) {
        navigate("/password-reset");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  

  return (
    <>
      <Box className="templateForm__inner --verification">
        <div className="templateForm__brand">
          <Icpassword />
        </div>
        <h3 className="templateForm__title">Hai dimenticato la password?</h3>
        <p>
          We&apos;ve sent a 6-digit confirmation email to your email.
          <br />
          Please enter the code below to verify your email.
        </p>
        {resetPasswordStatus && (
          <p style={{ color: "green" }}>{resetPasswordStatus}</p>
        )}
        {resetPasswordError && (
          <p style={{ color: "red" }}>{resetPasswordError}</p>
        )}
        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          sx={{ width: "100%" }}
        >
          <TextField
            {...register("email")}
            margin="normal"
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            autoFocus
            error={!!errors.email}
            helperText={errors.email?.message}
            placeholder="example@gmail.com"
            sx={{ mb: 3 }}
          />

          <Button
            className="loginBtn mt-0"
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              mb: 2,
              bgcolor: "#225CA6",
              "&:hover": {
                bgcolor: "#225CA6",
              },
              textTransform: "none",
            }}
          >
            Accedi
          </Button>

          <Box className="formLogin">
            <div
              className="formLogin__btn"
              href="login"
              variant="body2"
              sx={{
                textDecoration: "none",
                color: "text.secondary",
                display: "inline-flex",
                alignItems: "center",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
              onClick={() => navigate("/")}
            >
              ← Torna al login
            </div>
          </Box>
        </Box>
      </Box>
    </>
  );
}
